import { AfterContentInit, Input, OnDestroy, OnInit, Injectable } from '@angular/core';
import { AwallComponentEvent } from '../../../models/awallComponentEvent';
import { Issue } from '../../../models/issue';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { UserstoryService } from '../../../services/userstory.service';
import { SettingsService } from '../../../services/settings.service';
import { IKanbanGrid } from './iKanbanGrid';
import { BaseBoardComponent } from '../../../actionviews/baseBoard';
import { Observable } from 'rxjs';
import { BoardData } from '../../../models/boardData';
import { Listener, CommunicationService } from '../../../services/communication.service';

@Injectable()
export abstract class AbstractKanbanGrid extends BaseBoardComponent implements IKanbanGrid, OnDestroy,
  AfterContentInit, Listener<AwallComponentEvent> {

  @Input() public taskboardData = [];
  @Input() public expediteLaneData = [];
  public data: any;

  protected constructor(
    protected communicationService: CommunicationService,
    protected userStoryService: UserstoryService,
    protected settingsService: SettingsService
  ) {
    super();
  }

  protected abstract prepareIssues(userStoriesData);

  ngAfterContentInit() {
    this.prepareDataForBoard(this.data.taskboardData);
  }

  ngOnDestroy(): void {
    for (const ev of this.subscriptions) {
      ev.unsubscribe();
    }
  }

  public getBoardData(): Observable<BoardData> {
    // NOT IMPLEMENTED
    return null;
  }

  public prepareDataForBoard(userStoriesData) {
    this.prepareIssues(userStoriesData);
    this.prapreIssueColumnCount(userStoriesData);
  }

  protected prapreIssueColumnCount(userStoriesData) {
    this.data.boardConfiguration.columns.forEach(column => {
      let numOfIssues = 0;

      userStoriesData.forEach(task => {
        if (column.statusMatchesIssue(task)) {
          numOfIssues++;
        }
        task.tasks.forEach(subtask => {
          if (column.statusMatchesIssue(subtask)) {
            numOfIssues++;
          }
        });
      });
      column.setNumIssues(numOfIssues);
    });
  }

  onCommunicationEvent(event: AwallComponentEvent): void {
    super.onCommunicationEvent(event);
  }

  /**
   * Save the coordinates where the issuecard was released (used to create floating card at the right coordinates)
   */
  onCardReleased(event) {
    /* Bubble event */
    this.data.parent.onCardReleased(event);
  }

  /**
   * This fires when a closed issuecard (more precicely a list element of a cdkDroplist) is moved.
   * The cdkDragDrop will show a Drag-Preview element during drag.
   */
  onCardMoved(event) {
    /* Bubble event */
    this.data.parent.onCardMoved(event);
  }

  /**
   * A minified issue-card has been double clicked. Open the detailed Issuecard (if it doesnt exist already) without
   * changing the position/view of the minfied card.
   */
  onIssueDoubleClicked(event: MouseEvent, issue: Issue) {
    /* Bubble event */
    this.data.parent.onIssueDoubleClicked(event, issue);
  }

  onIssueDropped(event: CdkDragDrop<string[]>, expedited: boolean) {
    /* Bubble event */
    this.data.parent.onIssueDropped(event, expedited);
  }

  /**
   * Creates a sub task and adds it to a user story
   */
  createSubtask(userStoryId) {
    // Not implemented. Needs to be implemented using issuecomponent/issuecard
  }

}
